
const PRIMARY_COLOR = '#011546';
const SECONDARY_COLOR = '#759EFF';
const PRIMARY_ALTERNATIVE = '#F9383D';

export const OMNISCAN_BLUE = '#20afe8';
export const OMNISCAN_BLUE_RGB = "90, 155, 214";
export const OMNISCAN_BLUE_SOFT = "#8DC8F0";
export const OMNISCAN_BLUE_SOFT_RGB = "141, 200, 240";


export const COLOR_UTILISATION_OCCUPIED = "#E32636";
export const COLOR_UTILISATION_SIGNS_OF_LIFE = "#1769D2";
export const COLOR_UTILISATION_VACANT = "#00A84F";




export const COLOR_UTILISATION_OCCUPIED_OLD = "#E92864";
export const COLOR_UTILISATION_SIGNS_OF_LIFE_OLD = "#0327BC";
export const COLOR_UTILISATION_VACANT_OLD = "#38A500";



//export const TOOL_ICON_COLOR = "#1DDBD5";
export const TOOL_ICON_COLOR = "white";

export const OMNISCAN_CORPORATE_TURQUOIS       = "#1DDBD5";
export const OMNISCAN_CORPORATE_GREEN          = "#0CAC51";
export const OMNISCAN_CORPORATE_RED            = "#E92864";
export const OMNISCAN_CORPORATE_PINK           = "#EC6CF4";
export const OMNISCAN_CORPORATE_PURPLE         = "#3535D2";



export const OMNISCAN_CORPORATE_TURQUOIS_RGB   = "29, 219, 213";  // #1DDBD5
export const OMNISCAN_CORPORATE_GREEN_RGB      = "12, 172, 81";   // #0CAC51
export const OMNISCAN_CORPORATE_RED_RGB        = "234, 40, 99";   // #EA2863
export const OMNISCAN_CORPORATE_PINK_RGB       = "236, 108, 244"; // #EC6CF4
export const OMNISCAN_CORPORATE_PURPLE_RGB     = "53, 53, 210";   // #3535D2

export const SYSTEM_BLUE_BACKGROUND_LIGHT = "#116395";
export const COLOR_GRAY_BANNER_BACKGROUND = "#233142";
export const COLOR_DASHBOARD_BACKGROUND = "#f4f5f7";
export const DRAWER_AND_POP_UP_BACKGROUND = "#fdfdfd";

export const DARK_LOOK_BLACK = "#1A222E";
export const DARK_LOOK_BLACK_GREY ="#485363";
export const DARK_LOOK_GREY_BACKGROUND = "#FFFFFF";
export const DARK_LOOK_CHART_CARD_BACKGROUND = "#FFFFFF";
export const DARK_LOOK_CHART_TITLE_BACKGROUND = "#F3F3F3";
export const DARK_LOOK_CHART_BACKGROUND = "#F3F3F3";

export const BUTTON_BLUE_GRADIENT = "linear-gradient(180deg, rgba(66,133,244,1) 0%, rgba(30,88,182,1) 100%)";
export const BUTTON_BLUE_GRADIENT_LIGHT = "linear-gradient(180deg, #7EC8FF 0%, #2A82FF 100%)";


const returnColors = [
	"teal",
	"orange",
	"brown",
	"lightblue",
	"yellow",
	"purple",
	"pink",
	"lightgreen",
	"blue",
	"green",
	"darkred"
];

 const getPrimaryColor = () => {
 	if(sessionStorage.getItem("colorPrimary")){
 		return sessionStorage.getItem("colorPrimary");
 	}
 	else{
 		return PRIMARY_COLOR;
 	}
 	
 };
 
 const getSecondaryColor = () => {
	 	if(sessionStorage.getItem("colorSecondary")){
	 		return sessionStorage.getItem("colorSecondary");
	 	}
	 	else{
	 		return SECONDARY_COLOR;
	 	}
 };
 
 const getGradientColor = () => {
	 	if(sessionStorage.getItem("colorGradient")){
	 		return sessionStorage.getItem("colorGradient");
	 	}
	 	else{
	 		return "";
	 	}
 };

 const getHeaderColor = () => {
 	
	return PRIMARY_COLOR;
 };
 
 const getChartColor = () => {
	return SECONDARY_COLOR;
 };
 
 const getPrimaryAlternative = () => {
 	return PRIMARY_ALTERNATIVE;
 };
 
 const generateColorForIndex = (index) => {
 		return returnColors[index % returnColors.length];
 }

export const colorFunctions = {
	getPrimaryColor: getPrimaryColor,
	getSecondaryColor: getSecondaryColor,
	getHeaderColor: getHeaderColor,
	getChartColor: getChartColor,
	getPrimaryAlternative: getPrimaryAlternative,
	getGradientColor:getGradientColor,
	generateColorForIndex:generateColorForIndex
};

export const HEADER_FOOTER_COLOR = "#FAFBFC";

/* BASE DARK */
export const NAV_AND_TABS = "#2B2F34";
export const NAV_AND_TABS_HOVER = "#353A40";
export const INDICATOR_CENTRE = "#2B2F34";

/* GRADIENT VARIANTS */
export const NAV_GRADIENT =
  "linear-gradient(180deg, #2B2F34 0%, #1F2328 100%)";
  
  
  //export const TAB_GRADIENT =
  // "linear-gradient(180deg, #565C62 0%, #32373D 100%)";
   
   
  export const TAB_GRADIENT =
    "linear-gradient(135deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0.12) 12%, rgba(255,255,255,0.03) 24%, rgba(255,255,255,0) 38%), linear-gradient(to bottom, #2b2f34 0%, #131518 52%, #050607 100%)";
   
   
export const DRAWER_GRADIENT =  
"linear-gradient(180deg, #1b1b1b 0%, #0f0f0f 100%)" ;  


export const NAV_AND_TABS_HOVER_GRADIENT =
  "linear-gradient(180deg, #353A40 0%, #2A2F34 100%)";

export const INDICATOR_CENTRE_GRADIENT =
  "radial-gradient(circle at 35% 30%, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0.12) 18%, rgba(255,255,255,0.03) 35%, rgba(0,0,0,0) 45%), linear-gradient(to bottom, #2a2e33 0%, #111316 55%, #040506 100%)";
  
 
  

/* TEXT */
export const TEXT_LIGHT = "#F4F6F8";


